module.exports = __webpack_public_path__ + "static/media/talk22x.03ae5a34.png";